export class BeneficiaryDuplicateNames extends Error {
    constructor() {
        super("Name and Date of Birth can't be the same as another beneficiary'");
    }
}

export class BeneficiaryIsFinanciallyDependFalse extends Error {
    constructor() {
        super(
            'A beneficiary must financially depend on the insured person, or have an interest in their continued life, health, or safety.',
        );
    }
}

export class BeneficiaryHasNoPayoutOfHundredPercent extends Error {
    constructor() {
        super('Percentage must equal 100%');
    }
}
